import { Theme } from '@mui/material';

export const DashboardCss = {
  titleBoxCss: {
    marginTop: '24px'
  },
  snackBarSpanSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-primary)',
    textDecoration: 'underline',
    cursor: 'pointer'
  }
};

export const TitleRowCss = {
  mainTitleBox: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  welcomeSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-24)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-32)',
    color: 'var(--color-primary)',
    textTransform: 'capitalize'
  }
};

export const cardsCss = {
  gridContainer: {
    marginTop: 2
  },
  gridBoxCss: {
    padding: '24px',
    gap: '0px',
    borderRadius: '12px',
    opacity: ' 0px',
    backgroundColor: 'var(--color-white)',
    boxShadow: '0px 1px 8px 0px rgba(52, 52, 83, 0.14)'
  },
  headBox: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px'
  },
  headTextCss: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-20)',
    fontWeight: 700,
    lineHeight: 'var(--line-height-30)',
    textAlign: 'left',
    color: 'var(--color-text-secondary)'
  },
  numBoxCss: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    marginTop: '24px'
  },
  iconBoxCss: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px'
  },
  numTextCss: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-36)',
    fontWeight: 700,
    lineHeight: 'var(--line-height-44)',
    letterSpacing: '-0.02em',
    textAlign: 'left',
    color: 'var(--color-primary)'
  },
  perSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-18)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-28)',
    textAlign: 'left',
    color: 'rgba(18, 183, 106, 1)'
  },
  descSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-24)',
    textAlign: 'left',
    color: 'var(--color-text-secondary)'
  },
  descBoxSx: {
    marginTop: '38px'
  },
  tableHeadSx: {
    padding: '16px 0px 16px 0px'
  },
  tableCellPage: {
    paddingLeft: '0px !important'
  },
  tableCellTraffic: {
    paddingRight: '0px !important'
  },
  tHeadTextSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'var(--color-text-muted-purple)'
  },
  tHeadAlignment: {
    textAlign: 'left'
  },
  tCellText: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'rgba(41, 50, 65, 1)'
  },
  tCellPdfText: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 300,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'rgba(41, 50, 65, 1)'
  },
  dashSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-36)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-44)',
    letterSpacing: '-0.02em',
    textAlign: 'left',
    color: 'var(--color-text-secondary)'
  },
  loaderBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    mt: 3
  },
  dashBox: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '24px'
  },
  gifDiv: {
    position: 'fixed',
    inset: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 9999,
    display: 'flex',
    alignItems: 'flex-end', // align towards bottom
    justifyContent: 'center', // center horizontally
    paddingBottom: '5vh' // adjust how high the balloon floats (you can tweak)
  },
  gifImg: {
    width: 'auto',
    height: 'auto',
    maxWidth: '800px', // maximum width to control big screens
    maxHeight: '600px' // maximum height
  },
  keywordMainBox: {},
  keywordSubBox: {
    padding: '24px'
  }
};

export const newCardsCss = {
  headTextCss: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-24)',
    textAlign: 'left',
    color: 'var(--color-text-mid)'
  },
  urlSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'var(--color-primary)',
    marginTop: '5px'
  },
  progressTextSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-20)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-30)',
    textAlign: 'center',
    color: 'var(--color-text-purple)'
  },
  progressTextSpanSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-36)',
    fontWeight: 700,
    lineHeight: 'var(--line-height-44)',
    color: 'var(--color-primary)'
  },
  descBoxSx: (isDetailDashboardView) => ({
    padding: !isDetailDashboardView ? '0px 24px 16px 24px' : '0px 24px 0px 24px'
  }),
  numBoxCss: {
    marginTop: '24px'
  },
  iconBoxCss: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    justifyContent: 'center',
    minWidth: '80px'
  },
  gscNotConnectedSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-20)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-30)',
    textAlign: 'center',
    color: 'var(--color-text-muted)'
  },
  gscDescSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'center',
    color: 'var(--color-text-secondary)',
    marginTop: '16px'
  },
  gscImgStyle: {
    maxWidth: '200px',
    height: 'auto',
    marginTop: '32px'
  },
  gscImgBoxSx: {
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  gscBtnSx: {
    marginLeft: 'auto',
    marginRight: 'auto',
    padding: '12px 18px 12px 18px',
    gap: '8px',
    borderRadius: '6px',
    marginTop: '32px'
  },
  gscMainBoxSx: {
    padding: '24px',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  },
  tableCellIconSx: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
    justifyContent: 'end'
  },
  noChangesSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 600,
    lineHeight: '25px',
    color: 'var(--color-text-purple)'
  },
  gridContainerSx: {
    marginTop: '16px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'stretch' // Ensures cards have equal height
  },
  gridFirstSx: {
    display: 'flex'
  },
  firstCardSx: {
    boxShadow: '0px 1px 8px 0px var(--color-shadow-card)',
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    alignItems: 'flex-start',
    height: '100%', // Ensures the card fills the available height
    width: '100%' // Ensures card stretches in the grid
  },
  firstMainBoxSx: {
    //flex: 1
    width: '100%'
  },
  firstMainBoxSxTopBoxSx: (cardsHeight: string, isAiVisibility: unknown) => ({
    height: cardsHeight,
    display: 'flex',
    flexDirection: 'column',
    //justifyContent: isAiVisibility ? 'space-between' : 'flex-start'
    justifyContent: 'space-between'
  }),
  circularLoadingSx: {
    color: 'var(--color-primary)'
  },
  circleProgressBoxSx: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',

    marginLeft: 'auto',
    marginRight: 'auto'
  },
  bgCircleProgressSx: {
    position: 'absolute', // Stacks this circle
    color: 'rgba(242, 244, 247, 1)', // Remaining part color
    top: 0,
    left: 0
  },
  coloredCircleProgressSx: {
    position: 'absolute', // Stacks this circle on top of the background

    top: 0,
    left: 0,
    '& .MuiCircularProgress-circle': {
      strokeLinecap: 'round' // Adds the rounded end to the progress
    }
  },
  progressTextBoxSx: {
    position: 'absolute',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  trendingDownIconSx: {
    color: 'var(--color-error-bright)'
  },
  perNewSx: {
    fontSize: 'var(--font-size-16)',
    color: 'var(--color-error-bright)',
    marginLeft: '-2px'
  },
  trendingIconBoxSx: {
    display: 'flex',
    gap: '5px',
    alignItems: 'center'
  },
  goodScoreDescSx: {
    fontSize: 'var(--font-size-14)',
    color: 'var(--color-text-secondary)',
    lineHeight: 'var(--line-height-20)'
  },
  secondBoxSx: {
    display: 'flex',
    // justifyContent: 'space-between',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
    flex: 1
  },
  alertSx: {
    maxWidth: '500px',
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  googleAuthAlertSx: {
    '.MuiAlert-message': {
      overflowWrap: 'anywhere', // Ensures long words break to the next line
      whiteSpace: 'pre-wrap', // Preserves spacing and line breaks, allows wrapping
      //maxHeight: '200px', // Sets a maximum height for the alert content
      overflowY: 'auto' // Adds scroll if text exceeds the maxHeight
    }
  },
  organicSearchMainBoxSx: {
    padding: '24px',
    height: '100%'
  },
  organicSearchMainBoxSxTopBoxSx: (
    cardsHeight: string,
    isAiVisibility: unknown
  ) => ({
    height: cardsHeight,
    display: 'flex',
    flexDirection: 'column',
    //justifyContent: isAiVisibility ? 'space-between' : 'flex-start'
    justifyContent: 'space-between'
  }),
  graphBoxSx: {
    width: '100%',
    //height: '100px', // Set height for the container
    height: '60%',
    backgroundColor: 'transparent',
    paddingTop: '10px',
    paddingBottom: '20px'
  },
  topPagesMainBoxSx: {
    padding: '24px',
    height: '100%',
    //overflow: 'auto',
    '&::-webkit-scrollbar': {
      width: '1px',
      height: '3px'
    },
    '&::-webkit-scrollbar-track': {
      background: 'var(--color-bg-grey3)' // You can customize the track background color here
    },
    '&::-webkit-scrollbar-thumb': {
      borderRadius: '10px', // Add border-radius for a rounded scrollbar thumb
      background: 'var(--color-text-grey3)' // You can customize the thumb color here
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: 'var(--color-text-medium-grey)' // Customize thumb color on hover here
    }
  },
  tableSx: {
    minWidth: 50,
    borderRadius: '0px',
    boxShadow: 'none'
  },
  pageTypoSx: {
    fontSize: '12px',
    fontWeight: 500,
    color: 'var(--color-text-placeholder)'
  },
  tableRowSx: {
    '&:not(:last-child)': {
      borderBottom: '1px solid rgba(224, 224, 224, 1)'
    },
    height: '40px',
    fontFamily: 'Inter'
  },
  rowPageSx: {
    display: 'flex',
    alignItems: 'center' // Center the text vertically
  },
  trendingBoxSx: {
    display: 'flex',
    gap: '5px',
    alignItems: 'center'
  },
  trendingDownIconNewSx: {
    color: 'var(--color-error-bright)',
    width: '16px',
    height: '16px'
  },
  rowTrafficDiffSx: {
    fontSize: '13px !important',
    fontWeight: 500,
    color: 'var(--color-error-bright)',
    marginLeft: '-2px'
  },
  imgSx: {
    width: '16px',
    height: '16px'
  },
  rowTrafficDiffNewSx: {
    fontSize: '13px !important',
    fontWeight: 500
  },
  secondCardSx: {
    boxShadow: '0px 1px 8px 0px var(--color-shadow-card)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    height: '100%', // Ensures the card fills the available height
    width: '100%' // Ensures card stretches in the grid
  },
  typoSx: {
    fontSize: 'var(--font-size-14)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-20)'
  },
  celebrationTextBox: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  gscLoaderSx: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%'
  },
  sqspIconBox: {
    display: 'flex',
    alignItems: 'end',
    gap: '6px'
  },
  avatarSx: {
    height: '20px',
    width: '20px',
    borderRadius: 0
  },
  textBoxCss: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    justifyContent: 'flex-end'
  },
  boostVisibilityBtn: {
    maxHeight: '40px',
    padding: '12px 18px 12px 18px',
    borderRadius: '6px',
    border: '1px solid var(--color-border-muted)',
    boxShadow: '0px 1px 2px 0px var(--color-text-darkest)0D',
    fontWeight: 500
  },
  loadingContainer: (theme: Theme) => ({
    minHeight: theme.minHeights.md
  }),
  recommendedLoadingBox: (theme: Theme) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: theme.minHeights.md,
    height: '100%'
  }),
  newIconBoxCss: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    justifyContent: 'flex-end',
    // minWidth: '80px'
  },
  topicNamePdf: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-navy)',
    overflow: 'visible',
    textOverflow: 'unset',
    whiteSpace: 'normal' // enables wrapping to new lines
  },
  aiLoadingText: {
    fontSize: 'var(--font-size-16)',
    color: 'var(--color-text-secondary)',
    lineHeight: 'var(--line-height-22)',
    fontWeight: 500,
    textAlign: 'center',
    padding: '0px 12px 0px 12px'
  }
};

export const topOpportunitiesCss = {
  titleTextCss: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-20)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-30)',
    textAlign: 'left',
    color: 'var(--color-text-muted)'
  },
  chipSx: {
    width: 'auto',
    height: '24px'
  },
  chipGreenSx: {
    color: 'rgba(150, 200, 160, 1)'
  },
  chipRedSx: {
    color: 'rgba(100, 50, 50, 1)'
  },
  chipLabelSx: {
    fontFamily: 'Inter',
    fontSize: '13px',
    fontWeight: 700,
    lineHeight: 'var(--line-height-18)',
    textAlign: 'left',
    color: 'var(--color-text-muted)'
  },
  subHeadCss: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'var(--color-primary)',
    marginTop: '12px'
  },
  viewMoreBoxSx: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  viewMoreSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'var(--color-primary)',
    cursor: 'pointer'
  }
};

export const chartComponentsCss = {
  mainContainerCard: {
    boxShadow: '0px 1px 8px 0px rgba(52, 52, 83, 0.14)',
    borderRadius: '12px',
    marginBottom: '20px'
  },
  gscCardSx: {
    padding: '24px'
    // flexDirection: 'column'
  },
  gscDataBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    textAlign: 'center'
  },
  gscGridDataBox: {
    // marginLeft: 'auto',
    // marginRight: 'auto'
  },
  gscImgGridSx: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
    // marginLeft: 'auto',
    // marginRight: 'auto'
  },
  gscTitleSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-18)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-28)',
    textAlign: 'center',
    color: 'var(--color-text-muted)'
  },
  gscDescSx: {
    marginTop: '8px',
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-22)',
    textAlign: 'center',
    color: 'var(--color-text-tertiary)'
  },
  watchTutorialSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'var(--color-primary)',
    marginTop: '16px',
    cursor: 'pointer'
  },
  gscBtnSx: {
    padding: '10px 18px 10px 18px',
    gap: '8px',
    borderRadius: '6px',
    border: '1px',
    marginTop: '30px'
  },
  watchTutorialBox: {
    display: 'flex',
    alignItems: 'end',
    gap: '4px'
  },
  chartLoader: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '15rem'
  },
  gscAlert: {
    mt: 1,
    maxWidth: '100%',
    textAlign: 'left',
    fontFamily: 'Inter'
  }
};

export const dataGraphsCss = {
  mainGraphBox: {
    // padding: '24px'
  },
  tabBoxCss: {
    display: 'flex',
    alignItems: 'center',
    // justifyContent: 'center',
    gap: '8px'
  },
  tabNumSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-30)',
    fontWeight: 700,
    lineHeight: 'var(--line-height-38)',
    textAlign: 'left',
    marginTop: '14px'
  },
  tabTitleSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    textAlign: 'center'
  },
  tabsSx: {
    maxHeight: '96px',
    width: '100%'
  },
  loaderBox: {
    textAlign: 'center',
    marginTop: '5px'
  },
  menuTextSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'rgba(29, 41, 57, 1)'
  },
  noDataBox: {
    minHeight: '300px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    gap: '12px'
  },
  noDataText: {
    fontFamily: 'Inter',
    fontSize: '35px',
    fontWeight: 600,
    lineHeight: 'var(--line-height-24)',
    color: 'rgba(29, 41, 57, 1)'
  },
  gscTextSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'center',
    color: 'var(--color-text-secondary)'
  },
  graphToolTipContent: {
    borderRadius: '8px',
    backgroundColor: 'rgba(233, 236, 250, 1)',
    border: 'none',
    height: 'auto',
    maxHeight: '60px',
    paddingBottom: '2px'
  },
  graphToolTipLabel: {
    fontFamily: 'Inter',
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: 'var(--line-height-18)',
    color: 'var(--color-primary)'
  },
  graphToolTipItem: {
    fontFamily: 'Inter',
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: 'var(--line-height-18)',
    color: 'var(--color-primary)'
  },
  graphTooltipCursor: {
    stroke: 'rgba(243, 243, 243, 1)',
    strokeWidth: 2
  },
  graphSpan: {
    fontFamily: 'Inter',
    fontSize: '12px',
    fontWeight: 700,
    lineHeight: 'var(--line-height-20)',
    color: 'rgba(0, 0, 0, 0.38)'
  },
  graphXAxisTick: {
    fontFamily: 'Inter',
    fontSize: '12px',
    fontWeight: 400,
    color: 'var(--color-text-placeholder)'
  },
  graphYAxisTick: {
    fontFamily: 'Inter',
    fontSize: '12px',
    fontWeight: 400,
    color: 'var(--color-text-tertiary)'
  },
  graphToolTipDataLine: {
    width: '16px',
    height: '2px',
    backgroundColor: 'black',
    marginRight: '8px'
  },
  graphTooltipDataLineDiv: {
    display: 'flex',
    alignItems: 'center'
  },
  connectNowBtn: {
    maxHeight: '40px',
    padding: '12px 18px 12px 18px',
    borderRadius: '6px',
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-16)',
    lineHeight: 'var(--line-height-24)'
  }
};

export const recommendedNextStepsSxs = {
  mainTitleSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-24)',
    textAlign: 'left',
    color: 'var(--color-text-mid)'
  },
  paddingBox: {
    padding: '24px'
  },
  titleSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-24)',
    textAlign: 'left',
    color: 'var(--color-text-muted)'
  },
  titleBoxSx: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center'
  },
  titleDescSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'var(--color-text-secondary)',
    marginTop: '8px'
  },
  iconSx: {
    color: 'var(--color-text-tertiary)'
  },
  stepBoxSx: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  imgStyle: {
    width: '16px',
    height: '16px'
  },
  firstBoxSx: {
    maxWidth: '80%'
  },
  mainStepBoxSx: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'var(--color-bg-subtle)'
    }
  },
  gscErrorBoxSx: {
    Padding: '26px',
    paddingBottom: '26px',
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  gscDescSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'center',
    color: 'var(--color-text-muted)'
  },
  horizontalContainerSx: {
    borderRadius: '8px',
    width: '100%'
  },
  horizontalHeaderSx: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '16px 24px'
  },
  paginationControlsSx: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  paginationTextSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 400,
    color: 'var(--color-primary)'
  },
  paginationIconSx: (isBlue) => ({
    fontSize: 'var(--font-size-16)',
    color: isBlue ? 'var(--color-primary)' : 'var(--color-text-grey5)'
  }),
  horizontalStepsBoxSx: {
    display: 'flex',
    overflowX: 'hidden'
  },
  horizontalStepSx: {
    flex: '1 0 25%', // This makes each box take up 25% of the container width
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    textAlign: 'left',
    padding: '24px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'var(--color-bg-subtle)'
    },
    height: 'auto',
    justifyContent: 'space-between'
  },
  horizontalIconTitleBoxSx: {
    marginBottom: '8px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  horizontalTitleSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 600,
    color: 'var(--color-text-muted)',
    lineHeight: 'var(--line-height-22)'
  },
  horizontalDescSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 400,
    color: 'var(--color-text-secondary)',
    marginBottom: '8px',
    lineHeight: 'var(--line-height-22)'
  },
  viewDetailsSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-primary)',
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  viewDetailBox: (isChangeIcon, isDisabled) => ({
    display: 'flex',
    alignItems: 'center',
    gap: isChangeIcon ? '4px' : '8px',
    cursor: isDisabled ? 'not-allowed' : 'pointer',
    opacity: isDisabled ? 0.5 : 1
  }),
  eastIconSx: {
    fontSize: 'var(--font-size-18)',
    color: 'var(--color-text-mid)'
  },
  rightIcon: {
    fontSize: 'var(--font-size-18)',
    color: 'var(--color-primary)'
  },
  newChipSx: {
    width: '40px',
    height: '20px',
    paddingRight: '8px',
    paddingLeft: '8px',
    borderRadius: '4px',
    backgroundColor: 'var(--color-bg-purple-light2)',
    display: 'flex',
    alignItems: 'center'
  },
  newChipLabel: {
    fontFamily: 'Inter',
    fontWeight: '500',
    fontSize: '12px',
    lineHeight: 'var(--line-height-14)',
    color: 'var(--color-primary)'
  }
};

export const KeywordTrackingDataCss = {
  mainContainer: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  trackedKeywordsSx: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-16)',
    lineHeight: 'var(--line-height-24)',
    color: 'var(--color-text-mid)'
  },
  headBox: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  numBox: {
    marginTop: '24px'
  },
  btnSx: {
    maxHeight: '32px',
    gap: '4px',
    borderRadius: '6px',
    padding: '8px',
    border: '1px solid var(--color-text-muted-purple)'
  },
  descSx: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-secondary)',
    marginTop: '8px',
    marginBottom: '8px'
  },
  btnTextSx: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-primary)'
  },
  iconSx: {
    color: 'inherit',
    marginRight: '-9px',
    width: '20px',
    height: '20px'
  },
  loadingBox: {
    textAlign: 'center',
    marginTop: '12px'
  },
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    height: '100%'
  }
};

export const celebrationModalSx = {
  subBoxSx: {
    padding: '32px'
  },
  titleSx: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-24)',
    lineHeight: 'var(--line-height-32)',
    textAlign: 'center',
    color: 'var(--color-primary)',
    marginTop: '80px'
  },
  descSx: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-16)',
    lineHeight: 'var(--line-height-24)',
    textAlign: 'center',
    color: 'var(--color-text-secondary)',
    marginTop: '14px'
  },
  btnSx: {
    maxHeight: '48px',
    gap: '8px',
    paddingTop: '12px',
    paddingRight: '18px',
    paddingBottom: '12px',
    paddingLeft: '18px',
    borderRadius: '6px',
    marginTop: '16px'
  },
  btnText: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-16)',
    lineHeight: 'var(--line-height-24)',
    color: 'var(--color-white)'
  },
  bgImgBoxSx: {
    backgroundImage: 'url(/static/images/icons/celebration-bg.png)', // replace with your image path
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover', // or 'contain' depending on your image
    backgroundPosition: 'top center',
    height: '100px',
    width: '100%'
  },
  iconBtn: {
    height: '40px',
    padding: '8px',
    paddingRight: '23px',
    paddingTop: '42px'
  },
  iconBox: {
    width: '100%',
    display: 'flex',
    justifyContent: 'end'
  },
  circleMainBox: {
    width: '100%',
    height: '100%',
    minHeight: '146px',
    maxWidth: '146px',
    maxHeight: '146px',
    borderRadius: '50%',
    padding: '12px',
    boxShadow: '0px 0px 26.55px 0px #E3E3E3D9',
    backgroundColor: 'var(--color-white)',
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  circleProgressBoxSx: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    width: '126px', // Ensures both circles overlap
    height: '126px',
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  progressTextSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-30)',
    textAlign: 'center',
    color: 'var(--color-text-purple)'
  },
  progressTextSpanSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-24)',
    fontWeight: 700,
    lineHeight: 'var(--line-height-44)',
    color: 'var(--color-primary)'
  },
  descTitleSx: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-18)',
    lineHeight: 'var(--line-height-20)',
    textAlign: 'center',
    color: 'var(--color-text-secondary)',
    marginTop: '16px'
  },
  descTwoSx: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-16)',
    lineHeight: 'var(--line-height-20)',
    textAlign: 'center',
    color: 'var(--color-text-secondary)',
    marginTop: '16px'
  }
};

export const DashBoardViewToggleStyles = {
  root: {
    height: 42,
    border: '1px solid var(--color-border-neutral)',
    borderRadius: '6px',
    padding: '4px',
    backgroundColor: 'var(--color-white)',
    gap: '6px'
  },
  button: {
    textTransform: 'none',
    fontFamily: 'Inter, sans-serif',
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    letterSpacing: 0,
    minWidth: '116px',
    height: '32px',
    padding: '10px 16px',
    borderRadius: '4px !important',
    border: 'none',
    color: '#1A0050',
    fontWeight: 400,
    '&.Mui-selected': {
      backgroundColor: '#EDE9FE',
      fontWeight: 600,
      color: '#1A0050'
    },
    '&:hover': {
      backgroundColor: 'rgba(237, 233, 254, 0.6)'
    }
  },
  indicatorOuter: {
    position: 'absolute',
    top: '-8px',
    right: '-8px',
    width: '20px',
    height: '20px',
    borderRadius: '50%',
    backgroundColor: '#33DBBA40', // light green transparent outer circle
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  indicatorInner: {
    width: '12px',
    height: '12px',
    borderRadius: '50%',
    backgroundColor: 'var(--color-success-medium)' // solid green inner circle
  },
  tooltipSx: {
    cursor: 'pointer',
    lineHeight: '25px'
  }
};

export const YourMainCompetitorsStyles = {
  skeletonSx: {
    borderRadius: '100px',
    marginTop: '8px',
    marginBottom: '8px',
    padding: '5px'
  },
  noDataFoundSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-18)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'center',
    color: 'var(--color-text-secondary)'
  }
};

export const transferSitesCss = {
  mainBox: {
    padding: '24px'
  },
  title: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-20)',
    lineHeight: 'var(--line-height-30)',
    color: 'var(--color-primary)',
    textAlign: 'left',
    marginBottom: '14px'
  },
  desc: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-16)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-secondary)',
    textAlign: 'left',
    marginBottom: '14px'
  },
  btnSx: {
    maxHeight: '44px',
    padding: '12px 18px 12px 18px',
    borderRadius: '6px',
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-16)',
    lineHeight: 'var(--line-height-24)'
  }
};